var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app-body"}},[_c('nuxt'),_vm._v(" "),_c('a',{ref:"downloadLink"}),_vm._v(" "),_c('cookie-consent-banner')],1)}
var staticRenderFns = []

export { render, staticRenderFns }